import { useStyles } from "@webapps/styles";
import { Skeleton } from '@material-ui/lab';

const MyCalendarSkeleton = ({ calendarStyle }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div className={cx(classes.calendarContainer, calendarStyle)}>
      {/* Header avec mois et année */}
      <div className={classes.header}>
        <Skeleton
          variant="text"
          width="60%"
          height={24}
          className={classes.skeletonColor}
        />
      </div>

      {/* Jours de la semaine */}
      <div className={classes.weekDays}>
        {["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map(day => (
          <div key={day} className={classes.weekDay}>{day}</div>
        ))}
      </div>

      {/* Grille des jours du calendrier */}
      <div className={classes.daysGrid}>
        {/* Génère environ 35 jours (5 semaines) pour simuler un mois complet */}
        {[...Array(35)].map((_, index) => {
          // Simule quelques jours vides au début comme dans un vrai calendrier
          const isEmpty = index < 3;

          return isEmpty ? (
            <div key={`empty-${index}`} className={classes.emptyDay}></div>
          ) : (
            <div key={index} className={classes.dayContainer}>
              <Skeleton
                variant="rect"
                width={32}
                height={32}
                className={classes.skeletonColor}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  calendarContainer: {
    padding: spacing(2),
    backgroundColor: "#FFF",
    borderRadius: "10px",
    width: "calc(33.33% - calc(40px / 3))",
    "@media (max-width: 1700px)": {
      width: "calc(50% - calc(40px / 3))",
    },
    height: "350px",
    fontFamily: "Montserrat, sans-serif",
    "@media (max-width: 1535px)": {
      width: "calc(50% - calc(40px / 3))",
    },
    "@media (max-width: 1350px)": {
      width: "calc(100% - calc(40px / 3))",
    },
    "@media (max-width: 1110px)": {
      width: "calc(50% - calc(40px / 3))",
    },
    "@media (max-width: 840px)": {
      width: "calc(100% - calc(40px / 3))",
    },
  },
  header: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#152652",
    paddingBottom: spacing(2),
  },
  weekDays: {
    fontSize: "12px",
    fontFamily: "Roboto, sans-serif",
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    textAlign: "center",
    paddingBottom: spacing(1),
    borderBottom: "1px solid #E0E0E0",
    color: "#5D75A8",
  },
  weekDay: {
    color: "#5A6DA1",
    padding: spacing(1),
    fontFamily: "Roboto, sans-serif",
  },
  daysGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    paddingTop: spacing(1),
    gap: "10px 0px"
  },
  emptyDay: {
    visibility: "hidden",
  },
  dayContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "32px",
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    },
  },
});

export default MyCalendarSkeleton; 